module.exports = __webpack_public_path__ + "static/img/basemap.461d07d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/basemap.jpg
// module id = GMA/
// module chunks = 7